import React, { useEffect } from 'react';
import './psfomentoa2024.css';
import { psfomentoa2024 } from '../../json/psfomentoa2024';

const Psfomentoa2024 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'> {/* container, container-full-width, container container-mh */}
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Fomento Artesanal 2024"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                Mejorar el ingreso de las Personas Artesanas del Estado de Hidalgomediante la consolidación de acciones de comercialización, la asignación de espacios, el fomento de sus actividades económicas y la protección de sus tradiciones, a través de seis vertientes:
                <ol>
                  <li>
                  Promoción de productos artesanales o Registro de Marca.
                  </li>
                  <li>
                  Entrega de Financiamiento a Personas Artesanas.
                  </li>
                  <li>
                  Capacitación para el Rescate y la Preservación del Oficio Artesanal.
                  </li>
                  <li>
                  Entrega de Estímulos Económicos para el Reconocimiento de la Creatividad Artesanal. 
                  </li>
                  <li>
                  Asignación de Espacios para Comercialización de Artesanías.
                  </li>
                  <li>
                  Proyectos para el Fortalecimiento de Producción Artesanal.
                  </li>
                </ol>

                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Contribuir a mejorar el bienestar a través del ingreso de las Personas Artesanas Hidalguenses, mediante el impulso y desarrollo de actividades artesanales como son: Apoyos para promoción, producción, capacitación y comercialización.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Personas Artesanas que trabajen alguna rama artesanal descrita en el artículo 5 de la Ley Salvaguardia y Fomento Artesanal para el Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                El Programa está dirigido a las personas artesanas habitantes de los 84 municipios del Estado de Hidalgo que cuenten con alguna actividad artesanal considerada dentro de las 13 ramas artesanales que enuncia la Ley Salvaguardia y Fomento Artesanal para el Estado de Hldalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Subsecretaría de Participaciòn Social y Fomento Artesanal<br />
                  </li>
                  <li>Dirección General de Fomento Artesanal.<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Lic. Areli Maya Monzalvo: Subsecretaria de Participación Social y Fomento Artesanal
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                771 713 09 66 y 771 713 04 12
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}><strong>Reglas de Operación</strong></h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Fomento_Artesanal_2024_ene_31_alc7_05.pdf'
                target='_blank'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2024</a>
                </li>
                </ul>
                
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psfomentoa2024;